import dayjs from "dayjs";

export const handleDateKeyDown = (e) => {
  const input = e.target;
  const value = input.value;
  const cursor = input.selectionStart;

  const allowedKeys = [
    "Backspace", "Tab", "ArrowLeft", "ArrowRight",
    "Delete", "Home", "End", "Enter", "Escape"
  ];
  
  if (allowedKeys.includes(e.key)) return;

  const slashCount = (value.match(/\//g) || []).length;
  
  if (e.key === "/") {
    if (slashCount >= 2) {
      e.preventDefault();
      return;
    }

    if (cursor !== 2 && cursor !== 5) {
      e.preventDefault();
      return;
    }
  }

  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  if (cursor === 1) {
    const first = parseInt(value.charAt(0) || "0");
    const second = parseInt(e.key);
    const day = first * 10 + second;

    if (day < 1 || day > 31) {
      e.preventDefault();
      input.value = `0${first}/`;
      input.setSelectionRange(3, 3);
      return;
    }

    setTimeout(() => {
      if (!input.value.includes("/")) {
        input.value += "/";
        input.setSelectionRange(3, 3);
      }
    }, 0);

    return;
  }

  if (cursor === 4) {
    const first = parseInt(value.charAt(3) || "0");
    const second = parseInt(e.key);
    const month = first * 10 + second;

    if (month < 1 || month > 12) {
      e.preventDefault();
      input.value = value.slice(0, 3) + `0${first}/`;
      input.setSelectionRange(6, 6);
      return;
    }

    setTimeout(() => {
      if (input.value.charAt(5) !== "/") {
        input.value += "/";
        input.setSelectionRange(6, 6);
      }
    }, 0);

    return;
  }

  if (cursor >= 6) {
    const year = value.slice(6).replace(/\D/g, "");
    if (year.length >= 4) {
      e.preventDefault();
      return;
    }
  }
};

export const handleDateInput = (e) => {
  let val = e.target.value.replace(/[^0-9/]/g, "");

  const parts = val.split("/");

  let day = parts[0] || "";
  let month = parts[1] || "";
  let year = parts[2] || "";

  if (day.length === 2) {
    if (parseInt(day) < 1) day = "01";
    if (parseInt(day) > 31) day = "31";
  }

  if (month.length === 2) {
    if (parseInt(month) < 1) month = "01";
    if (parseInt(month) > 12) month = "12";
  }

  if (year.length > 4) {
    year = year.slice(0, 4);
  }

  let newVal = day;
  if (month) newVal += "/" + month;
  if (year) newVal += "/" + year;

  e.target.value = newVal;
};

export const handleDateBlur = (e, callback) => {
  let v = e.target.value;

  if (!v) return;

  const [d, m, y] = v.split("/");

  if (!d || !m || !y) return;

  const day = d.padStart(2, "0");
  const month = m.padStart(2, "0");
  const year = y.padStart(4, "0");

  const final = `${day}/${month}/${year}`;
  const dateObj = dayjs(final, "DD/MM/YYYY");

  if (dateObj.isValid()) {
    if (callback) {
      callback(dateObj.toDate());
    }
    e.target.value = final;
  }
};

export const blockPaste = (e) => e.preventDefault();

const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const handleDateInputDebounced = debounce(handleDateInput, 50);